export interface ProgressStep {
  key: string
  label: string
}

interface ProgressTrackerProps {
  steps: ProgressStep[]
  activeKey: string
}

// Active step = burnt-orange dot + burnt-orange label (ux_decisions 2026-05-25).
// Completed = filled navy dot. Upcoming = hollow outline dot.
export default function ProgressTracker({ steps, activeKey }: ProgressTrackerProps) {
  const activeIndex = steps.findIndex((s) => s.key === activeKey)
  return (
    <nav aria-label="Onboarding progress">
      <ol className="flex items-center justify-center gap-2 md:gap-3">
        {steps.map((step, i) => {
          const isActive = i === activeIndex
          const isComplete = activeIndex >= 0 && i < activeIndex
          return (
            <li key={step.key} className="flex items-center gap-2">
              <span
                className={[
                  'h-2 w-2 shrink-0 rounded-full',
                  isActive
                    ? 'bg-ob-accent'
                    : isComplete
                      ? 'bg-ob-ink'
                      : 'border border-ob-secondary/40',
                ].join(' ')}
                aria-hidden="true"
              />
              <span
                aria-current={isActive ? 'step' : undefined}
                className={[
                  'whitespace-nowrap font-label text-[11px] uppercase tracking-wider',
                  isActive
                    ? 'font-semibold text-ob-accent'
                    : isComplete
                      ? 'text-ob-ink'
                      : 'text-ob-secondary/60',
                ].join(' ')}
              >
                {step.label}
              </span>
              {i < steps.length - 1 && (
                <span
                  className="hidden h-px w-5 bg-ob-secondary/20 sm:block md:w-8"
                  aria-hidden="true"
                />
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
